module.exports = new __parcel__URL__("holystrike.218ed7b5.png").toString();